<template>
<el-main>
  <el-container class="user-profile-container">
    <back-to-list
      :label="$t($i18nLabelsHelper(getOrganizationData.type, 'all_users'))"
      :backTo="backToOrganizationUsers"
    />

    <el-row type="flex" class="user-profile" :gutter="32">
      <el-col :md="12" :xs="24">
        <div id="user-data" class="profile-section">
          <div class="outer">
            <h3>{{$t("organizations.users_section.user_profile.user_details.title")}}</h3>
            <div>
              <initial-avatar v-bind="$attrs" :avatarUrl="getOrganizationUserData.photo_url" size="large" :userObject=getOrganizationUserData />
            </div>
            <info-row :label="$t('user_profile.your_profile.first_name')" :value="getOrganizationUserData.first_name" />
            <info-row :label="$t('user_profile.your_profile.last_name')" :value="getOrganizationUserData.last_name" />
            <info-row
            :label="$t('user_profile.your_profile.email')" :value="getOrganizationUserData.email"
            >
            <p>{{getOrganizationUserData.email}}</p>
            </info-row>
            <info-row :label="$t('user_profile.your_profile.user_name')" :value="getOrganizationUserData.username" />
            <info-row :label="$t('user_profile.your_profile.phone_number')" :value="getCompletePhoneNumber" />
          </div>
        </div>
      </el-col>

      <el-col :md="12" :xs="24">
        <div id="user-organizations" class="profile-section">
          <div class="outer">
            <h3>{{$t("organizations.users_section.user_profile.user_roles.title")}}</h3>
            <div class="organization-row">
              <div class="organization-row-info">
                <!-- <h3 class="organization-user-position">{{getOrganizationUserData.department}}, {{getOrganizationUserData.title}}</h3> -->
                <div class="organization-user-roles">
                  <role
                    v-for="(role, idx) in getOrganizationUserData.roles"
                    :key="idx"
                    :label="$labelRole(getOrganizationData.type, role).toLowerCase()"
                  />
                </div>
              </div>
              <chip
                @click.native="modals.editProfileModal = true"
                icon="elsa-icon-edit"
              >
                {{ $t("common.edit") }}
              </chip>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <div class="organization-user-profile-modals">
      <edit-organization-user
      :dialogVisible="modals.editProfileModal"
      :organizationUserData.sync="getOrganizationUserData"
      v-on:closed="modals.editProfileModal = false"
      :organizationId="organizationId"
      width="755px"
      />
    </div>
  </el-container>
</el-main>
</template>

<script>
  import parsePhoneNumber from '@/utils/parsePhoneNumber'
  import InfoRow from '@/components/common/InfoRow'
  import Role from '@/components/common/Role'
  import Chip from '@/components/common/Chip'
  import EditOrganizationUser from '@/components/modals/organizations/EditOrganizationUser'
  import BackToList from '@/components/common/BackToList'
  import InitialAvatar from '@/components/common/InitialAvatar'
  import { mapGetters } from 'vuex'

  export default {
    components:{
      InfoRow,
      Role,
      Chip,
      EditOrganizationUser,
      BackToList,
      InitialAvatar
    },
    props: {
      organizationId: {
      },
      userId: {
      },
    },
    data() {
      return {
        modals: {
          editProfileModal: false,
        },
        getOrganizationUserData: {},
      }
    },
    computed: {
      getCompletePhoneNumber () {
        const phoneCode = this.getOrganizationUserData.phoneCode
        const phoneNumber = this.getOrganizationUserData.phoneNumber

        return parsePhoneNumber(phoneCode, phoneNumber)
      },
      
      ...mapGetters({
        getOrganizationData: 'organization/currentOrganization'
      })
    },
    methods: {
      backToOrganizationUsers() {
        return this.$router.push({
          name:'organization',
            params: {
              organizationId: this.organizationId,
              tab: 'users'
          }
        })
      }
    },
    async mounted() {
      const organizationId = this.organizationId
      const userId = this.userId
      this.getOrganizationUserData = await this.$store.dispatch('organization/getOrganizationUser',  {organizationId, userId})
    }
  }
</script>

<style lang="scss" scoped>
@import '../scss/_colors.scss';

#user-organizations .outer .organization-row {
  display: flex;
  justify-content: space-between;

  .organization-row-info {
    display: flex;
    flex-direction: column;

    .organization-user-position {
      font-weight: 500;
      font-size: 14px;
      color: $dark-blue-2;
    }

    .organization-user-roles {
      display: flex;
      flex-direction: row;

      span:first-of-type {
        margin-left: 0;
      }

      span:last-of-type {
        margin-right: 0;
      }
    }
  }
}

</style>
